import bilalabdulhadii from "../assets/devs/bilalabdulhadii.jpg";
import emmameruem from "../assets/devs/emmameruem.jpg";

const developers = {
    bilalabdulhadii: {
        id: "bilalabdulhadii",
        name: "Bilal Abdulhadi",
        role: "Web Developer",
        bio: "Computer engineer and web developer focused on building reliable, user-friendly platforms and digital products. Passionate about clean interfaces, thoughtful UX, and scalable engineering that turns ideas into real-world impact.",
        avatar: bilalabdulhadii,
        url: "https://bilalabdulhadi.com",
        instagram: "https://instagram.com/bilalabdulhadii",
        facebook: "https://facebook.com/bilalabdulhadii",
        linkedin: "https://linkedin.com/in/bilalabdulhadii",
        github: "https://github.com/bilalabdulhadii",
    },
    emmameruem: {
        id: "emmameruem",
        name: "Emma Meruem",
        role: "Web Developer",
        bio: "Computer engineer and web developer who builds modern, performant web experiences. Interested in product strategy, accessible design, and creating smooth digital journeys that help teams and users move faster.",
        avatar: emmameruem,
        url: "https://bilalabdulhadi.com",
        instagram: "https://instagram.com/bilalabdulhadii",
        facebook: "https://facebook.com/bilalabdulhadii",
        linkedin: "https://linkedin.com/in/bilalabdulhadii",
        github: "https://github.com/bilalabdulhadii",
    },
};

export default developers;
